import React from 'react';
import { Button } from '@/components/ui/button';
import { Heart, Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useSessionLike } from '@/hooks/useCommunitySocial';

interface LikeButtonProps {
  sessionId: string;
  size?: 'sm' | 'default';
  showCount?: boolean;
  className?: string;
}

export const LikeButton: React.FC<LikeButtonProps> = ({
  sessionId,
  size = 'default',
  showCount = true,
  className,
}) => {
  const { likeCount, isLiked, toggleLike, isToggling, canLike } = useSessionLike(sessionId);

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    toggleLike();
  };

  return (
    <Button
      variant="ghost"
      size={size}
      onClick={handleClick}
      disabled={isToggling}
      className={cn(
        'gap-1.5 transition-colors',
        isLiked && 'text-red-500 hover:text-red-600',
        !canLike && 'opacity-70',
        className
      )}
      title={canLike ? (isLiked ? 'Unlike' : 'Like') : 'Sign in to like'}
    >
      {isToggling ? (
        <Loader2 className={cn(
          'animate-spin',
          size === 'sm' ? 'h-4 w-4' : 'h-5 w-5'
        )} />
      ) : (
        <Heart
          className={cn(
            size === 'sm' ? 'h-4 w-4' : 'h-5 w-5',
            isLiked && 'fill-current'
          )}
        />
      )}
      {showCount && <span>{likeCount}</span>}
    </Button>
  );
};

export default LikeButton;
